import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getCompanyDetails = createAsyncThunk(
  "getCompanyDetails",
  async (id) => {
    try {
      const token = localStorage.getItem("cu_user");
      const url = `${process.env.REACT_APP_API_HOST}/api/company/${id}`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      ;
      return data;
    } catch (error) {
      console.error(error);
    }
  }
);

// export const getCompanyUnitDetails = createAsyncThunk(
//   "getCompanyUnitDetails",
//   async (id) => {
//     try {
//       const token = localStorage.getItem("cu_user");
//       const url = `${process.env.REACT_APP_API_HOST}/api/company-unit/${id}`;
//       const { data } = await axios.get(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       ;
//       return data;
//     } catch (error) {
//       console.error(error);
//     }
//   }
// );

export const getCompanies = createAsyncThunk("getCompanies", async ({programId}) => {
  try {
    const token = localStorage.getItem("cu_user");
    const url = `${process.env.REACT_APP_API_HOST}/api/company?programs=${programId}`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    ;
    return data;
  } catch (error) {
    console.error(error);
  }
});

export const CompanySlice = createSlice({
  name: "Company",
  initialState: {
    companyDetails: [],
    allCompanies: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: {
    [getCompanyDetails.pending]: (state) => {
      state.status = "pending";
    },
    [getCompanyDetails.fulfilled]: (state, action) => {
      state.status = "success";
      state.error = action.error;
      state.companyDetails = action.payload;
    },
    [getCompanyDetails.rejected]: (state, action) => {
      state.status = "failed";
      state.companyDetails = null;
      state.error = action.error;
    },
    [getCompanies.pending]: (state) => {
      state.status = "pending";
    },
    [getCompanies.fulfilled]: (state, action) => {
      state.status = "success";
      state.error = action.error;
      state.allCompanies = action.payload;
    },
    [getCompanies.rejected]: (state, action) => {
      state.status = "failed";
      state.allCompanies = null;
      state.error = action.error;
    },
  },
});

export default CompanySlice.reducer;
